export default {
  logInWithSpotify: (() => {
    window.spotifyAuthPopup = window.open(
      'https://s6q60if5n2.execute-api.eu-west-1.amazonaws.com/qa/auth/spotify/login',
      'Login with Spotify',
      'width=600,height=800'
    );
  })
};